// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
import Text from 'components/Form/Text'
import Select from 'components/Form/Select'
import { loop } from 'utilities/objects'

// Redux:
import { getFilteredActivities, clearFilteredActivities } from 'actions/page'

class ActivitiesFilters extends React.Component {
	constructor() {
		super()

		this.state = {
			search: '',
			theme: '',
			min_time: '',
			max_time: '',
			min_group_size: '',
			max_group_size: '',
			age: ''
		}

		this.typingTimer
		this.doneTypingInterval = 1200
	}

	componentDidMount() {

	}

	handleChange = ( id, value ) => {
		this.setState( {
			[ id ]: value
		}, () => {
			if ( 'search' == id || 'min_group_size' == id || 'max_group_size' == id ) {
				// Get data after there has been at least doneTypingInterval time after the last change.
				if ( this.typingTimer ) {
					clearTimeout( this.typingTimer )
				}

				this.typingTimer = setTimeout( this.getData, this.doneTypingInterval )
			} else {
				// this.props.dispatch( getFilteredActivities( this.state ) )
				this.getData()
			}
		} )
	}

	getData = () => {
		this.props.dispatch( getFilteredActivities( this.state ) )
	}

	clearFilters = () => {
		this.setState( {
			search: '',
			theme: '',
			min_time: '',
			max_time: '',
			min_group_size: '',
			max_group_size: '',
			age: ''
		} )

		this.props.dispatch( clearFilteredActivities() )
	}

	render() {
		const { postsData } = this.props
		const { search, theme, min_time, max_time, min_group_size, max_group_size, age } = this.state

		if ( ! postsData || ! postsData.categories ) {
			return null
		}

		let themeOptions = [ {
			name: '',
			value: ''
		} ]

		loop( postsData.categories, ( key, item ) => {
			themeOptions.push( {
				name: item.title,
				value: item.id
			} )
		} )

		const timeOptions = [
			{
				name: '',
				value: ''
			},
			{
				name: '5 minutes',
				value: '5'
			},
			{
				name: '15 minutes',
				value: '15'
			},
			{
				name: '30 minutes',
				value: '30'
			},
			{
				name: '1 hour',
				value: '60'
			},
			{
				name: '1.5 hours',
				value: '90'
			},
			{
				name: '2 hours',
				value: '120'
			},
			{
				name: '2.5 hours',
				value: '150'
			},
			{
				name: '3 hours',
				value: '180'
			},
			{
				name: '4 or more hours',
				value: '240'
			}
		]
		const ageOptions = [
			{
				name: '',
				value: ''
			},
			{
				name: '10-12 years',
				value: '10-12'
			},
			{
				name: '12-14 years',
				value: '12-14'
			},
			{
				name: '14-16 years',
				value: '14-16'
			},
			{
				name: '16+ years',
				value: '16-plus'
			},
			{
				name: '8-10 years',
				value: '8-10'
			}
		]

		return (
			<div className="activities-filters">
				<div className="-inner">
					<form className="form" action="" onSubmit={ this.handleSubmit }>
						<div className="form-item form-items-row">
							<Text
								id="search"
								label="Search"
								onChange={ this.handleChange }
								type="text"
								value={ search }
							/>

							<Select
								id="theme"
								label="Theme"
								onChange={ this.handleChange }
								value={ theme }
								options={ themeOptions }
							/>
						</div>

						<div className="form-item form-items-row">
							<Select
								id="min_time"
								label="Min time"
								onChange={ this.handleChange }
								type="text"
								value={ min_time }
								options={ timeOptions }
							/>

							<Select
								id="max_time"
								label="Max time"
								onChange={ this.handleChange }
								value={ max_time }
								options={ timeOptions }
							/>
						</div>

						<div className="form-item form-items-row">
							<Text
								type="number"
								id="min_group_size"
								label="Min group size"
								onChange={ this.handleChange }
								value={ min_group_size }
							/>

							<Text
								type="number"
								id="max_group_size"
								label="Max group size"
								onChange={ this.handleChange }
								value={ max_group_size }
							/>
						</div>

						<div className="form-item form-items-row">
							<Select
								id="age"
								label="Age level"
								onChange={ this.handleChange }
								value={ age }
								options={ ageOptions }
							/>

							<div className="form-item -item-button">
								<div className="button -cancel" onClick={ this.clearFilters }>Clear</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		postsData: state.page.selected
	}
}

export default connect( mapStateToProps )( ActivitiesFilters )



// WEBPACK FOOTER //
// ./components/Activities/ActivitiesFilters.jsx